import React from "react"
import { ListSection } from '../common'

const BUTTON_COLORS = {
    GitHub: "bg-[#24292e]",
    Colab: "bg-gradient-to-bl from-[#EA4335] to-[#FBBC05]"
}
const DEFAULT_BUTTON_COLOR = "bg-stone-400 dark:bg-stone-600"

const Button = ({ label, url, open_tab }) => {
    const bgColor = BUTTON_COLORS[label] ?? DEFAULT_BUTTON_COLOR

    return(
        <a target={open_tab ? "_blank" : "_self"} rel="noreferrer" className="dark:text-stone-200" href={url}>
            <div className={`px-2 xl:px-4 py-1 xl:py-2 rounded-xl xl:rounded-2xl ${bgColor}`}>{label}</div>
        </a>
    )
}

const ProjectItem = ({ title, photo, description, buttons }) => {
    return(
        <div className='flex flex-col'>
            <div className='h-full rounded-xl xl:rounded-2xl 2xl:rounded-3xl px-4 xl:px-8 2xl:px-10 py-2 xl:py-4 2xl:py-6 bg-stone-200 dark:bg-stone-400'>
                
                <div className='font-bold xl:text-3xl 2xl:text-4xl dark:text-white'>{title}</div>

                <div className='pt-2 xl:pt-4 2xl:pt-6 flex'>

                    <div className='size-1/3 flex aspect-square items-center bg-stone-100 justify-center rounded-xl 2xl:rounded-3xl'>
                        <img className="object-cover rounded-xl 2xl:rounded-3xl" alt="" src={photo} />
                    </div>

                    <div className="flex w-2/3 pl-4 xl:pl-6 2xl:pl-8">
                        <div className='text-xs xl:text-xl 2xl:text-3xl dark:text-white'>
                            {description}
                        </div>

                    </div>

                </div>

                <div className="w-full flex justify-end gap-2 2xl:gap-4 text-xs xl:text-xl 2xl:text-2xl pt-2 text-white">
                    { buttons.map( (button) => (<Button key={button.label} {...button}/>) ) }
                </div>
                
            </div>

        </div>
    )
}

export const Projects = ({ projects }) => {
    const title = "PROJECTS"
    const description = "Some of the side projects that I worked on:"

    return (
        <ListSection title={title} description={description}>
            <div className='flex flex-col sm:grid xl:grid-cols-2 gap-4 xl:gap-10 2xl:gap-18 justify-between mt-2 xl:flex-row'>
                {projects.map((project) => (
                    <ProjectItem key={project.title} {...project} />
                ))}
            </div>
        </ListSection>
  )
}
